import { useState } from "react";

import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";

import SubtitledLabel from "@/components/SubtitledLabel";

import { Customer } from "@/extensions/klarahill/types";

interface SendEmailDialogProps {
  mainContact: Customer;
  onChange: (recipient: string) => void;
}

const SendEmailDialog: React.FC<SendEmailDialogProps> = ({
  mainContact,
  onChange,
}) => {
  const [sendToOther, setSendToOther] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "500px" }}>
      <FormControl>
        <RadioGroup
          value={sendToOther}
          onChange={(_, value) => {
            if (value === "true") {
              setSendToOther(true);
              onChange(email);
            } else {
              setSendToOther(false);
              onChange(mainContact.email);
            }
          }}
        >
          <FormControlLabel
            control={<Radio />}
            label={
              <SubtitledLabel
                subtitle={`${mainContact.first_name} ${mainContact.last_name} <${mainContact.email}>`}
                title="Skicka till anhörig"
              />
            }
            value={false}
          />
          <FormControlLabel
            control={<Radio />}
            label={
              <Typography variant="subtitle2">
                Skicka till annan mottagare
              </Typography>
            }
            value={true}
          />
        </RadioGroup>
      </FormControl>

      {sendToOther && (
        <Box sx={{ marginLeft: "32px" }}>
          <TextField
            fullWidth
            helperText="Kom ihåg att gästlistan innehåller persondata om gästerna."
            label="E-post"
            size="small"
            type="email"
            value={email}
            onChange={({ currentTarget: { value: email } }) => {
              setEmail(email);
              onChange(email);
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SendEmailDialog;
